module.exports = __webpack_public_path__ + "img/car-shadow-1.f2efb31f.png";